import React, { Fragment, useContext, useState } from "react";
import Cookies from "js-cookie";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import toaster from "toasted-notes";

import "toasted-notes/src/styles.css";
import { formatKoboBalance } from "../../../../../../utils/utilityFunctions";
import { NormalText, SemiBoldText, SmallHeaderText } from "../../../../common/common.styles";
import { TotalChargeWrapper } from "../../../catalogue/items/components/catalogue.styles";
import Button from "../../../../../../library/otherButton/Button";
import { updateSalesOrder } from "../../../../../../redux/actions/salesOrder.acton";
import { ActionTypes, ChargeItemsContext } from "../../../catalogue/context";

const TotalSummaryCharge = ({ orderData, totalPrice }) => {
    const [isSubmitting, setIsSubmitting] = useState(false);

    const dispatch = useDispatch();
    const history = useHistory();
    const { contextDispatch } = useContext(ChargeItemsContext);

    const handleUpdateOrder = async () => {
        setIsSubmitting(true);
        const groupCustomerId = Cookies.get("groupCustomerId");
        const payload = {
            id: orderData.id,
            ownerID: groupCustomerId,
            items: orderData?.items?.map((item) => ({
                id: item.id,
                quantity: item.quantity,
            })),
            status: 2,
        };

        try {
            const { status, message } = await dispatch(updateSalesOrder(payload));
            setIsSubmitting(false);

            if (status) {
                contextDispatch({
                    type: ActionTypes.INITIATE_ORDER,
                    payload: {
                        id: orderData?.id,
                        orderID: orderData?.orderID,
                    },
                });
                history.push("/sales/catalogue/checkout");
            } else {
                toaster.notify(message || "Sorry, an error occurred, Kindly try again.", {
                    duration: 5000,
                    position: "bottom",
                });
            }
        } catch (error) {
            setIsSubmitting(false);
        }
    };
    return (
        <Fragment>
            <TotalChargeWrapper fromOrderHistory>
                <div className="sales__sub-total-item-wrap">
                    <NormalText>Sub Total:</NormalText>
                    <NormalText>{formatKoboBalance(totalPrice)}</NormalText>
                </div>
                <div className="sales__sub-total-item-wrap">
                    <NormalText>Tax 1:</NormalText>
                    <NormalText>₦0.00</NormalText>
                </div>
                <div className="sales__sub-total-item-wrap">
                    <NormalText>Tax 2:</NormalText>
                    <NormalText>₦0.00</NormalText>
                </div>
                <div className="sales__sub-total-item-wrap sales__total-item-wrap">
                    <SemiBoldText>Total:</SemiBoldText>
                    <SmallHeaderText className="sales__sum-total-amount">
                        {formatKoboBalance(totalPrice)}
                    </SmallHeaderText>
                </div>
                {orderData.status === 2 && (
                    <div className="sales__pay-buttons-wrap">
                        <Button
                            text="Charge"
                            width="100%"
                            onButtonClick={handleUpdateOrder}
                            isSubmitting={isSubmitting}
                            disabled={orderData?.items?.length < 1}
                        />
                    </div>
                )}
            </TotalChargeWrapper>
        </Fragment>
    );
};

export default TotalSummaryCharge;
